import React, {Component} from "react";

import WeekMode from "../enums/weekMode";
import WeekRepository from "../data/WeekRepository";
import WeekSwitcher from "../components/WeekSwitcher";
import Week from "../components/Week";
import Navbar from "../components/Navbar";

export default class TimeTrackingWeeklyOverview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedEntry: null,
            currentWeek: 1,
            weekMode: WeekMode.WorkWeek
        };

        this.weekRepository = new WeekRepository();
        this.setCurrentWeek(this.state.currentWeek);
    }

    onSelectedEntryChanged = (id) => {
        this.setState({selectedEntry: id});
    };

    onCurrentWeekChanged = (id) => {
        this.setState({currentWeek: id});
        this.setCurrentWeek(id);
    };

    onWeekModeChanged = (weekMode) => {
        this.setState({weekMode: weekMode});
    };

    setCurrentWeek = (id) => {
        this.week = this.weekRepository.getCalendarWeek(id);
    };

    render() {
        return (
            <div className="app">
                <Navbar>
                    <WeekSwitcher
                        currentWeek={this.state.currentWeek}
                        weekNumbers={[1, 2, 4]}
                        weekMode={this.state.weekMode}
                        onCurrentWeekChanged={this.onCurrentWeekChanged}
                        onWeekModeChanged={this.onWeekModeChanged}
                    />
                </Navbar>
                <div className="container-fluid">
                    <Week
                        key={this.state.currentWeek}
                        model={this.week}
                        selectedEntry={this.state.selectedEntry}
                        weekMode={this.state.weekMode}
                        onSelectedEntryChanged={this.onSelectedEntryChanged}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/TimeTrackingWeeklyOverview.js